import { defaultSounds, SoundService as BaseSoundService } from '@pascal/pascal-core';

defaultSounds.win = null;
defaultSounds.betAccepted = null;
defaultSounds.music.loop = false;
defaultSounds.music.src = 'sounds/music.mp3';
defaultSounds.music.onplay = function () {
  this._sounds[0]._node.bufferTime = 0.5; // need it for safari
}
defaultSounds.music.onend = function () {
  soundService.playMusic();
}

const SoundNames = {
  WheelSound: 'WHEEL_SOUND',
  SingleClick: 'SINGLE_CLICK',
};

class SoundService extends BaseSoundService {
  constructor(options) {
    super({ options });
    this._once = false;
  }

  init(initConfig) {
    if (!this._once) {
      this._once = true;
      return super.init(initConfig);
    }
  }

  click() {
    return this.play(SoundNames.SingleClick);
  }

  startWheelSound() {
    return this.play(SoundNames.WheelSound);
  }

  stopWheelSound() {
    return this.stop(SoundNames.WheelSound);
  }
}

export const soundService = new SoundService([
  {
    name: SoundNames.WheelSound,
    src: 'sounds/wheel_sound.mp3',
    loop: false,
    autoplay: false,
    html5: true,
  },
  {
    name: SoundNames.SingleClick,
    src: 'sounds/singleClick.wav',
    loop: false,
    autoplay: false,
    html5: true,
  },
]);